import Components from "@constants/Components";
import OrganisationSettingsActions from "@pages/OrganisationSettings/constants/OrganisationSettingsActions";
import OrganisationSettingsComponents from "@pages/OrganisationSettings/constants/OrganisationSettingsComponents";
import ParticipantsActions from "@pages/Participants/constants/ParticipantsActions";
import ParticipantsComponents from "@pages/Participants/constants/ParticipantsComponents";

export const Home = [
    {
        action: "route",
        component: Components.HOME,
        element: '[data-cy="menu-home-button"]',
        popover: {
            description: "tour_home_home_description",
            title: "tour_home_home_title",
        },
    },
    {
        action: OrganisationSettingsActions.ADD_TREE_NODE_ACTION,
        component: OrganisationSettingsComponents.ORGANISATION_SETTINGS,
        element: "#create_profile",
        popover: {
            description: "tour_home_create_profile_description",
            title: "tour_home_create_profile_title",
        },
    },
    {
        action: ParticipantsActions.REQUEST_ASSESSMENT,
        component: ParticipantsComponents.PARTICIPANTS,
        element: "#request_assessment",
        popover: {
            description: "tour_home_request_assessment_description",
            title: "tour_home_request_assessment_title",
        },
    },
    {
        action: "route",
        component: ParticipantsComponents.PARTICIPANTS,
        element: "#search_participant",
        popover: {
            description: "tour_home_search_participant_description",
            title: "tour_home_search_participant_title",
        },
    },
    {
        action: "route",
        component: OrganisationSettingsComponents.ORGANISATION_SETTINGS,
        element: "#organisationSettings",
        popover: {
            description: "tour_home_organisations_description",
            title: "tour_home_organisations_title",
        },
    },
];
